import React from "react";
import {useAuth} from "../../modules/auth";
import {getAskedPermission} from "../../utils/Utils";

export function PermissionInfo({entityId}) {
    const {currentUser} = useAuth();

    let allowedPermission = getAskedPermission(entityId, currentUser.permissions);

    if (allowedPermission == null) {
        return getHtml("You do not have access to this feature, Please contact your Administrator to get access.");
    }

    function getHtml(message) {
        return (
            <div className="text-center py-3">
                <span
                    className="text-gray-400 fw-normal fs-9"
                    dangerouslySetInnerHTML={{__html: message}}/>
            </div>
        );
    }

    if (
        !allowedPermission ||
        !allowedPermission.read ||
        !allowedPermission.delete ||
        !allowedPermission.update ||
        !allowedPermission.create
    ) {
        let permissions = [];
        if (allowedPermission.read) permissions.push("Read");
        if (allowedPermission.update) permissions.push("Update");
        if (allowedPermission.create) permissions.push("Create");
        if (allowedPermission.delete) permissions.push("Delete");

        let message = "Limited access to " + allowedPermission.permission + " &middot; " + permissions.join(", ");

        return getHtml(message);
    }

    return null;
}
